document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ba-slider').forEach(function(slider) {
    var range   = slider.querySelector('.ba-range');
    var after   = slider.querySelector('.ba-slider__after');
    var divider = slider.querySelector('.ba-slider__divider');
    var handle  = slider.querySelector('.ba-slider__handle');
    function update(val) {
      after.style.clipPath = 'inset(0 ' + (100 - val) + '% 0 0)';
      divider.style.left   = val + '%';
      handle.style.left    = val + '%';
    }
    range.addEventListener('input', function() { update(this.value); });
    update(50);
  });
});
